import React from 'react';
import { useHistory } from 'react-router-dom';

export default function AddForm() {
  const history = useHistory();
  return (
    <div className="col-2">
      <button
        className="btn btn-primary float-right"
        id="new-form-btn"
        type="button"
        onClick={() => history.push('./forms/form-builder')}
      >Add Form
      </button>
    </div>
  );
}
